"use client";
import { TextSkeleton } from "./TextSkeleton.js";
import { CircularSkeleton } from "./CircularSkeleton.js";
import { RectangularSkeleton } from "./RectangularSkeleton.js";
export {
  CircularSkeleton,
  RectangularSkeleton,
  TextSkeleton
};
